import { c as _c } from "react/compiler-runtime";
import { Skeleton } from "@/shared/components/ui/skeleton";

// Placeholder shown while the session-aware auth cluster streams in. Widths
// roughly match the real buttons so the nav doesn't jump when it resolves.
export const NavAuthSkeleton = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="hidden items-center gap-1.5 md:flex"><Skeleton className="h-9 w-16 rounded-full" /><Skeleton className="h-9 w-28 rounded-full" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};